export default __webpack_public_path__ + "static/media/image-088.f0eadc08.jpeg";